import { Loader2 } from 'lucide-react';

export function FullPageSpinner({ label = 'Loading…' }: { label?: string }) {
  return (
    <div role="status" className="flex h-screen items-center justify-center text-muted-foreground" aria-live="polite">
      <Loader2 className="mr-2 h-5 w-5 animate-spin" />
      <span>{label}</span>
    </div>
  );
}
